import React, { FC } from 'react';
import PRLineItemsComponent from './PRLineItemsComponent';

const PurchaseRequestLineItemsIndexPage: FC<any> = () => {
	return <PRLineItemsComponent />;
};

export default PurchaseRequestLineItemsIndexPage;
